/**
 * CorpHourlyChart — Hourly bar+line chart for the selected campus.
 */

import HourlyLineAndBarChart from '../../../../components/charts/HourlyLineAndBarChart.jsx';

const CorpHourlyChart = ({ chartData, campusName }) => {
    return (
        <div className="md-section">
            <h3 className="md-section__title" style={{ marginBottom: 'var(--space-4)' }}>
                Events by Hour {campusName ? `for ${campusName}` : ''} (Last 28 Days)
            </h3>
            <div className="md-chart-container">
                <HourlyLineAndBarChart
                    style={{ maxHeight: '350px' }}
                    labels={chartData?.labels || Array.from({ length: 24 }, (_, i) => String(i))}
                    x_axis={true} x_axis_title="Hour of the Day"
                    bar_axis={true} bar_axis_title="Total Alarms" bar_color="#0081C7"
                    line_axis={true} line_axis_title="Avg Response Time (min)" line_color="#BE4D25"
                    bar_data={chartData?.events || chartData?.avg_events || []}
                    line_data={chartData?.responses || []}
                    bar_annotation={true} bar_annotation_value={chartData?.avgValue || null}
                    line_annotation={true} line_annotation_value={chartData?.avgResp || 0}
                    forceAspect={true}
                />
            </div>
        </div>
    );
};

export default CorpHourlyChart;
